<template>
    <div class="safe-page">
        <header class="top-nav">
            <button type="button" class="back-btn" @click="$router.back()">
                <van-icon name="arrow-left" />
            </button>
            <div class="nav-title">{{ $t('safe.setting') }}</div>
        </header>

        <main class="page-content">
            <section class="settings-group">
                <div class="group-title">{{ getLabel('pageSafe.accountSecurity', '账户安全') }}</div>

                <div class="setting-item">
                    <div class="item-left">
                        <div class="item-icon">
                            <van-icon name="checked" />
                        </div>
                        <div class="item-copy">
                            <strong>{{ $t('safe.verified') }}</strong>
                            <span>{{ data.is_auth == '1' ? $t('safe.verifiedIdentity') : getLabel('pageSafe.unverifiedIdentity', '未完成身份认证') }}</span>
                        </div>
                    </div>
                    <router-link v-if="data.is_auth == '0'" to="/authEmail" class="item-action">
                        {{ $t('safe.toVerify') }}
                        <van-icon name="arrow" />
                    </router-link>
                    <span v-else class="item-status success">{{ $t('safe.verifiedIdentity') }}</span>
                </div>

                <router-link to="/language" class="setting-item link-item">
                    <div class="item-left">
                        <div class="item-icon">
                            <van-icon name="service-o" />
                        </div>
                        <div class="item-copy">
                            <strong>{{ $t('safe.language') }}</strong>
                            <span>{{ getLabel('pageSafe.languageHint', '切换系统显示语言') }}</span>
                        </div>
                    </div>
                    <van-icon name="arrow" class="arrow-icon" />
                </router-link>

                <router-link to="/setpwd" class="setting-item link-item">
                    <div class="item-left">
                        <div class="item-icon">
                            <van-icon name="lock" />
                        </div>
                        <div class="item-copy">
                            <strong>{{ $t('safe.signInPassword') }}</strong>
                            <span>{{ getLabel('pageSafe.signInHint', '修改账户登录密码') }}</span>
                        </div>
                    </div>
                    <van-icon name="arrow" class="arrow-icon" />
                </router-link>

                <router-link to="/setpaypwd" class="setting-item link-item">
                    <div class="item-left">
                        <div class="item-icon">
                            <van-icon name="cash-back-record" />
                        </div>
                        <div class="item-copy">
                            <strong>{{ $t('safe.paymentPassword') }}</strong>
                            <span>{{ getLabel('pageSafe.paymentHint', '设置或更新支付密码') }}</span>
                        </div>
                    </div>
                    <van-icon name="arrow" class="arrow-icon" />
                </router-link>
            </section>

            <section class="settings-group">
                <div class="group-title">{{ getLabel('pageSafe.platformPolicy', '平台协议') }}</div>

                <router-link to="/about/12" class="setting-item link-item">
                    <div class="item-left">
                        <div class="item-icon">
                            <van-icon name="description" />
                        </div>
                        <div class="item-copy">
                            <strong>{{ $t('index.agreement') }}</strong>
                            <span>{{ getLabel('pageSafe.viewAgreement', '查看平台服务协议') }}</span>
                        </div>
                    </div>
                    <van-icon name="arrow" class="arrow-icon" />
                </router-link>

                <router-link to="/about/13" class="setting-item link-item">
                    <div class="item-left">
                        <div class="item-icon">
                            <van-icon name="shield-o" />
                        </div>
                        <div class="item-copy">
                            <strong>{{ $t('index.secret') }}</strong>
                            <span>{{ getLabel('pageSafe.viewPrivacy', '查看平台隐私政策') }}</span>
                        </div>
                    </div>
                    <van-icon name="arrow" class="arrow-icon" />
                </router-link>
            </section>

            <button type="button" class="logout-btn" @click="logout">
                {{ $t('safe.signOut') }}
            </button>
        </main>
    </div>
</template>

<script>
import Fetch from "../../utils/fetch";
import Vue from "vue";
import { Icon } from "vant";

Vue.use(Icon);

export default {
    name: "safe",
    data() {
        return {
            data: {},
            appOriginalStyles: null,
            bodyOriginalBackground: "",
        };
    },
    created() {
        this.$parent.footer("user", false);
    },
    mounted() {
        this.applyFullScreenLayout();
        this.start();
    },
    beforeDestroy() {
        this.restoreFullScreenLayout();
    },
    methods: {
        getLabel(key, defaultText) {
            return this.$te(key) ? this.$t(key) : defaultText;
        },
        applyFullScreenLayout() {
            const app = document.getElementById("app");
            if (!app) {
                return;
            }
            this.appOriginalStyles = {
                maxWidth: app.style.maxWidth,
                width: app.style.width,
                margin: app.style.margin,
                backgroundColor: app.style.backgroundColor,
                paddingBottom: app.style.paddingBottom,
            };
            this.bodyOriginalBackground = document.body.style.background;
            app.style.maxWidth = "100%";
            app.style.width = "100%";
            app.style.margin = "0";
            app.style.backgroundColor = "#000000";
            app.style.paddingBottom = "0";
            document.body.style.background = "#000000";
        },
        restoreFullScreenLayout() {
            const app = document.getElementById("app");
            if (app && this.appOriginalStyles) {
                app.style.maxWidth = this.appOriginalStyles.maxWidth || "";
                app.style.width = this.appOriginalStyles.width || "";
                app.style.margin = this.appOriginalStyles.margin || "";
                app.style.backgroundColor = this.appOriginalStyles.backgroundColor || "";
                app.style.paddingBottom = this.appOriginalStyles.paddingBottom || "";
            }
            document.body.style.background = this.bodyOriginalBackground || "";
        },
        start() {
            Fetch("/user/info").then((r) => {
                this.data = r.data || {};
            });
        },
        logout() {
            localStorage.removeItem("token");
            this.$router.replace("/login");
        },
    },
};
</script>

<style lang="less" scoped>
.safe-page {
    min-height: 100vh;
    background: #000;
    color: #fff;
}

.top-nav {
    position: sticky;
    top: 0;
    z-index: 50;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 56px;
    padding: 0 16px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
    background: rgba(0, 0, 0, 0.9);
    backdrop-filter: blur(12px);
}

.back-btn {
    position: absolute;
    left: 16px;
    top: 50%;
    width: 28px;
    height: 28px;
    margin-top: -14px;
    border: 0;
    background: transparent;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
}

.back-btn .van-icon {
    font-size: 22px;
}

.nav-title {
    font-size: 18px;
    font-weight: 700;
}

.page-content {
    width: 100%;
    max-width: 430px;
    margin: 0 auto;
    padding: 24px 14px 30px;
    box-sizing: border-box;
}

.settings-group {
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.03);
    backdrop-filter: blur(12px);
}

.settings-group {
    overflow: hidden;
    margin-bottom: 18px;
}

.group-title {
    padding: 16px 16px 10px;
    color: rgba(255, 255, 255, 0.74);
    font-size: 13px;
    font-weight: 700;
}

.setting-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 16px;
    border-top: 1px solid rgba(255, 255, 255, 0.05);
    color: #fff;
    text-decoration: none;
}

.setting-item:first-of-type {
    border-top: 0;
}

.item-left {
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 0;
    flex: 1;
}

.item-icon {
    width: 42px;
    height: 42px;
    border-radius: 12px;
    background: rgba(45, 91, 255, 0.12);
    color: #2d5bff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.item-icon .van-icon {
    font-size: 22px;
}

.item-copy {
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.item-copy strong {
    color: #fff;
    font-size: 15px;
    font-weight: 700;
}

.item-copy span {
    color: rgba(255, 255, 255, 0.48);
    font-size: 12px;
    line-height: 1.5;
}

.item-action,
.item-status {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: #2d5bff;
    font-size: 13px;
    font-weight: 700;
    text-decoration: none;
    flex-shrink: 0;
}

.item-status.success {
    color: #3ddc84;
}

.arrow-icon,
.item-action .van-icon {
    color: rgba(255, 255, 255, 0.35);
    font-size: 18px;
}

.logout-btn {
    width: 100%;
    height: 48px;
    border: 0;
    border-radius: 12px;
    background: rgba(239, 68, 68, 0.12);
    color: #ff6b7b;
    font-size: 15px;
    font-weight: 700;
}
</style>
